export default {
  bouyguesSIMCard: {
    id: 'bouygues_SIM_card_item_label',
    defaultMessage:
      'Once Bouygues Telecom confirms your account info, you’ll get a confirmation email. Your SIM card and phone will arrive separately within 6 business days.',
  },
}
